import React from 'react'
import './Preview.sass'
import {Link} from 'react-router-dom'
// import

export default () =>
  <div className='rootDir'>
    <div className="manage">
      <div className="manage-text">
        <h1 className="manage-text__title">
          Автоматизированная информационная система для технологической подготовки производства
        </h1>
        <p className="manage-text__subtitle">
          Функциональное назначение АИС ТПП: автоматизация разработки технологических процессов
        </p>

        <Link to="/modules/input/blank" className="manage-text__module">
          Переход к программным модулям
        </Link>
      </div>
    </div>
  </div>